import React from "react";

const About = () => {
  return (
    <>
      <div className="w-[85vw] mlg:w-[90vw] smp:w-[93vw] mx-auto py-10">
        <div className="w-full mx-auto mt-[14%] xxl:mt-[20%] xl:mt-[22%] mlg:mt-[28px] ">
          <div className="text-[#6D6D6D]  sm:text-[14px] font-semibold inter">
            ABOUT
          </div>
          <div className="pt-2 pb-4">
            <h1 className="text-[#000000] font-bold text-[30px] sm:text-2xl inter">
              Solution that you need
            </h1>
          </div>
          <div>
            <p className="text-[#232323] font-medium lg:font-normal text-[20px] lg:text-[18px] sm:text-[16px] inter">
              At PARSAL Logistic, we are committed to simplifying the shipping
              process for businesses of all sizes. With a focus on innovation
              and customer satisfaction, our team works tirelessly to provide
              top-notch logistics solutions.
            </p>
            <p className="text-[#232323] font-medium lg:font-normal text-[20px] lg:text-[18px] sm:text-[16px] inter my-3">
              We are committed to simplifying the shipping process for
              businesses of all sizes. With a focus on innovation and customer
              satisfaction, our team works tirelessly to provide top-notch
              logistics solutions.
            </p>
            <p className="text-[#232323] font-medium lg:font-normal text-[20px] lg:text-[18px] sm:text-[16px] inter">
              We are committed to simplifying the shipping process for
              businesses of all sizes. With a focus on innovation and customer
              satisfaction, our team works tirelessly to provide top-notch
              logistics solutions.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
